import { Link } from "react-router-dom";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function PrivacyPolicy() {
  const { formatted_phone, client_email } = useSiteConfig();
  
  return (
    <div data-testid="privacy-policy-page" className="pt-20">
      {/* Hero */}
      <section className="py-16 bg-[#1a1a1a] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 
            className="text-4xl md:text-5xl font-bold uppercase tracking-wide"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            Privacy Policy
          </h1>
          <p className="text-gray-400 mt-2">Last updated: February 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg">
          <h2>1. Information We Collect</h2>
          <p>
            Overhaul Ops LLC ("we," "our," or "us") collects information you provide directly to us when you:
          </p>
          <ul>
            <li>Fill out contact forms on our website</li>
            <li>Request a quote or service</li>
            <li>Subscribe to our communications</li>
            <li>Communicate with us via phone, email, or chat</li>
          </ul>
          
          <p>This information may include:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Physical address</li>
            <li>Service preferences</li>
            <li>Payment information</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process transactions and send related information</li>
            <li>Send promotional communications (with your consent)</li>
            <li>Respond to your comments, questions, and requests</li>
            <li>Monitor and analyze trends and usage</li>
          </ul>

          <h2>3. Information Sharing</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal information to third parties except as described in this policy. We may share information with:
          </p>
          <ul>
            <li>Service providers who assist in our operations</li>
            <li>Professional advisors (lawyers, accountants)</li>
            <li>Law enforcement when required by law</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.
          </p>

          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of marketing communications</li>
          </ul>

          <h2>6. Cookies and Tracking</h2>
          <p>
            Our website may use cookies and similar tracking technologies to enhance your experience. You can control cookie preferences through your browser settings.
          </p>

          <h2>7. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party sites. We are not responsible for their privacy practices.
          </p>

          <h2>8. Children's Privacy</h2>
          <p>
            Our services are not intended for children under 13. We do not knowingly collect information from children.
          </p>

          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this policy from time to time. We will notify you of any changes by posting the new policy on this page.
          </p>

          <h2>10. Contact Us</h2>
          <p>If you have questions about this Privacy Policy, please contact us:</p>
          <ul>
            <li><strong>Business:</strong> Overhaul Ops LLC</li>
            <li><strong>Phone:</strong> {formatted_phone}</li>
            <li><strong>Email:</strong> {client_email || "overhaulops.llc@gmail.com"}</li>
            <li><strong>Service Area:</strong> Denton, Tarrant, Parker, and Wise Counties, Texas</li>
          </ul>

          <div className="mt-8 p-4 bg-gray-100 rounded-sm">
            <p className="text-sm text-gray-600">
              See also our <Link to="/sms-policy" className="text-[#b51a00] hover:underline">SMS/Text Message Policy</Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
